module.exports = __webpack_public_path__ + "static/media/tiger_t.40ebbe70.png";